export default __webpack_public_path__ + "static/aluminiumHero-b23df34643f7ad180d22362630d20b8f.jpg";